import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Typography,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import * as EmailValidator from 'email-validator';

import Button from '../Button'
import TabPanel from '../../components/TabPanel';

function PracticeEditModal(props) {
  const {
    practice,
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
    }
  } = props;

  const [id, setId] = useState('')
  const [name, setName] = useState('')
  const [catchAllEmail, setCatchAllEmail] = useState('')
  const [validationErrors, setValidationErrors] = useState({})

  useEffect(() => {
    if (practice) {
      setId(practice.id)
      setName(practice.name)
      setCatchAllEmail(practice.catchAllEmail)
    }
  }, [])

  const validate = () => {
    let valid = true
    let nextState = {}
    if (!name) {
      nextState.name = 'Required'
      valid = false
    }
    if (catchAllEmail && !EmailValidator.validate(catchAllEmail)) {
      nextState.catchAllEmail = 'Must be a vaild email'
      valid = false
    }
    setValidationErrors(nextState);
    return valid
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{practice.name || 'New Practice'}</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>


      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Profile" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              label="Name"
              value={name}
              onChange={event => {
                setValidationErrors({ ...validationErrors, name: false })
                setName(event.target.value)
              }}
              error={validationErrors.name}
              helperText={validationErrors.name}
              className={input}
            />

            <TextField
              fullWidth
              variant="outlined"
              label="Catch all email"
              value={catchAllEmail}
              onChange={event => {
                setValidationErrors({ ...validationErrors, catchAllEmail: false })
                setCatchAllEmail(event.target.value)
              }}
              error={validationErrors.catchAllEmail}
              helperText={validationErrors.catchAllEmail}
              className={input}
            />
            <Typography variant="body2">
              The "Catch all email" can be <strong>any</strong> email address and will receive all
              notifications for the entire practice.
            </Typography>
          </DialogContent>

          <Grid container justifyContent="flex-end" classes={{ container: actions }}>
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => save({ id, name, catchAllEmail })}
                onClickValidation={validate}
              >
                Save Practice
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

PracticeEditModal.propTypes = {
  practice: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(PracticeEditModal);
